import React from "react";
import { Rating } from "semantic-ui-react";

export default class StarScale extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            rating: 0,
        };
    }
    handleRate = (e, { rating, maxRating }) =>
        this.setState({ rating, maxRating }, () => {
            this.props.handleClick(this.state.rating);
        });

    setHover = () => this.setState({ hovered: true });
    removeHover = () => this.setState({ hovered: false });

    render() {
        let componentStyles = {
            default: {},
            grid: {},
        };
        return (
            <Rating
                style={componentStyles[this.props.layout]}
                icon="star"
                size={this.props.size}
                maxRating={this.props.max}
                onRate={this.handleRate}
            />
        );
    }
}
